// gkc_hash_code : 01GKRBSM6TJAQ3DYFRPWJ69CPX

import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
import 'lazysizes';

function App() {
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
